import { Provider } from '@angular/core';
import { provideRecaptchaTokenInterceptor } from './recaptcha-token-interceptor.provider';

export function provideAuth(): Provider {
  return [provideRecaptchaTokenInterceptor()];
}
